import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Gallery.css';
import gallery1 from '../images/gallery1/1.jpg';
import gallery2 from '../images/gallery1/2.jpg';
import gallery3 from '../images/gallery1/3.jpg';
import gallery4 from '../images/gallery1/4.jpg';
import gallery5 from '../images/gallery1/5.jpg';
import gallery6 from '../images/gallery1/6.jpg';
import gallery7 from '../images/gallery1/7.png';
import gallery8 from '../images/gallery1/8.png';

const Gallery = () => {
  const images = [
    gallery4,
    gallery7,
    gallery2,
    gallery5,
    gallery1,
    gallery8,
    gallery3,
    gallery6
  ];

  return (
    <section className="gallery-section" id="gallery">
      <Container>
        <div className="section-header text-center mb-5">
          <h2 className="section-title">Our Gallery</h2>
          <p className="section-subtitle">Caring Moments Captured</p>
        </div>
        
        <Row className="g-4">
          {images.map((image, index) => (
            <Col key={index} lg={3} md={4} sm={6}>
              <div className="gallery-item">
                <img src={image} alt={`Gallery ${index + 1}`} />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Gallery;
